<template>
    <CustomizerFallback v-if="builderContentMissing" />
    <Content
        v-else-if="canShowContent"
        :model="model"
        :content="content"
        :api-key="apiKey"
        :customComponents="customComponents"
    />
    <div v-else class="step-loading-container">
        <LoadingIndicator />
    </div>
</template>

<script>
import { Content } from "@builder.io/sdk-vue";
import LoadingIndicator from "../LoadingIndicator.vue";
import CustomizerFallback from "../CustomizerFallback.vue";

export default {
    name: "CustomizerStepShell",
    components: {
        Content,
        LoadingIndicator,
        CustomizerFallback,
    },
    props: {
        builderContentMissing: Boolean,
        canShowContent: Boolean,
        model: { type: String, default: "page" },
        content: { type: Object, default: null },
        apiKey: { type: String, required: true },
        customComponents: { type: Array, required: true },
    },
};
</script>

<style lang="scss" scoped>
.step-loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 50vh;
    width: 100%;
}
</style>
